module.exports = __webpack_public_path__ + "img/guoqing-pop.734a169b.png";